import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import Loader from "../../helpers/Loader";
import { useLazyGetPromoByIdQuery } from "../../services/promocodes";
import moment from "moment";
import { errorToast } from "../../helpers";
import Subject from "../../features/category/Subject";
import { useGetCategoryByIdQuery } from "../../services/category";

const SubjectCategoryDetails = () => {
  const navigate = useNavigate();
  const { _id } = useParams();
  const [catDetails, setCatDetails] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { data: categoryData } = useGetCategoryByIdQuery({ id: _id });

  // const fetchCategories = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await getAllCat({
  //     }).unwrap();
  //     if (response.statusCode === 200) {
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setIsLoading(false);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng"> Category Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-subject-category")}
          >
            Back
          </Button>
        </div>
        {/* <Loader isLoad={isLoading} /> */}

        <Card className="cards">
          <CardContent sx={{ p: 3 }}>
            <Grid container spacing={3} className="view_box_list">
              <Grid item xs={12}>
                <Typography className="custom_label">Category Name</Typography>
                <Typography component="p">
                  {categoryData?.data?.name || "Core Academic Subjects"}
                </Typography>
              </Grid>

              <Grid item sm={6} xs={12}>
                <Box>
                  <Typography component="h5">CreatedAt</Typography>
                  <Typography component="p">
                    {" "}
                    {categoryData?.data?.createAt ||
                      new Date().toISOString().split("T")[0]}
                  </Typography>
                </Box>
              </Grid>

              <Grid item sm={6} xs={12}>
                <Box>
                  <Typography component="h5">Status</Typography>
                  <Typography component="p">
                    {categoryData?.data?.status ? "Active" : "Inactive"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Card
              className="cards"
              sx={{
                mt: 2,
              }}
            >
              <div className="dashboard">
                <h1 className="mn_hdng">Subjects</h1>
              </div>
              {/* <Box className="custom_tabs"> */}
              <Subject />
              {/* </Box> */}
            </Card>
          </CardContent>
        </Card>
      </div>
    </MainContainer>
  );
};

export default SubjectCategoryDetails;
